<template>
    <div class="app_center">
      
            <div class="app_main">
                <p class="app_title">应用中心</p>
                <div class="app-list">
                    <div class="app-item" v-for="item in appList" @click="viewAppDetail(item)">
                        <div class="app-cover">
                            <img v-if="item.logo !== null" :src="item.logo.url" alt="" class="app-icon">
                            <img v-else src="../../assets/img/image/no_cover.png" alt="" class="app-icon">
                        </div>
                        <span class="app-name" :title="item.app_name">{{ item.app_name }}</span>
                    </div>
                    <div class="noData" v-if="appList.length==0">
                        <img src="../../assets/teacherIcon/noDataye.png" alt="">
                        <p>暂无数据</p>
                    </div>
                </div>
            </div>
     

        <el-dialog title="欢迎使用yikeSoft" :visible.sync="dialogAppDetail" width="800px" center class="app-detail-dialog"
            :close-on-click-modal="false">
            <template #title>
                <p class="title">欢迎使用yikeSoft</p>
            </template>
            <div class="app-detail-content">
               
                <div class="h2">{{ appInfo.appTitle }}</div>
                <span class="soft_introduction">软件功能介绍：</span>
                <div class="content">


                    <div class="soft-content">{{ appInfo.appContent }}</div>
                    <div class="info-dialog-footer">

                        <div class="link_item">
                            <img src="../../assets/teacherIcon/shouye.png" alt="">
                            <a :href="appInfo.home_link" target="_blank" class="home">首页登录</a>
                        </div>
                        <div class="link_item">
                            <img src="../../assets/teacherIcon/shangjia.png" alt="">
                            <a :href="appInfo.shop_link" target="_blank" class="shop">商家登录</a>
                        </div>
                        <div class="link_item">
                            <img src="../../assets/teacherIcon/jiaoshi.png" alt="">
                            <a :href="appInfo.teacher_link" target="_blank" class="shop">教师登录</a>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="info-dialog-footer">



            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data() {
        return {
            appList: [],
            dialogAppDetail: false,
            //应用信息
            appInfo: {
                appTitle: '',
                appContent: '',
                home_link: '',
                shop_link: '',
                teacher_link: '',
            },

        }
    },
    methods: {
        viewAppDetail(item) {
            this.dialogAppDetail = true;
            this.appInfo.appTitle = item.app_name;
            this.appInfo.appContent = item.intro;
            this.appInfo.home_link = item.home_link;
            this.appInfo.shop_link = item.shop_link;
            this.appInfo.teacher_link = item.teacher_link;
        },
        getApplicationData() {
            this.$thttp.axiosGet(this.$api.getAllocation, res => {
                if (res.code = 200) {
                    if (res.data.appcenter_ids) {
                        let appcenter_ids = JSON.parse(res.data.appcenter_ids);
                        appcenter_ids.forEach(item => {
                            this.getAppList(item.school_app_id)
                        })
                    }
                }
            })
        },
        getAppList(id) {
            this.$thttp.axiosGetBy(this.$api.app_showApp, { id: id ? id : 0 }, res => {
                if (res.code = 200) {
                    this.appList.push(res.data.data[0])
                }

                //应用排序，排列顺序跟总管理员应用中心一样
                function compare(property) {
                    return function (a, b) {
                        let value1 = a[property];
                        let value2 = b[property];
                        return value2 - value1;
                    }
                }

                this.appList.sort(compare('parent_id'));
            }
            )
        },
    },
    mounted() {
        this.getApplicationData()
    }
}


</script>
<style lang="scss" scoped>
.app_center {
    width: 100%;
    // height: 100%;
    min-height: calc(100vh - 72px);
    display: flex;
    justify-content: center;
    // align-items: center;
    background-color: #ffffff;
    padding: 40px;
    box-sizing: border-box;
    

}

.app_main {
    width:75%;
    
    // background-color: pink;


    .app_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #3C3C3C;
        line-height: 38px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }

    .app-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .app-item {
            width: 192px;
            height: 160px;
            background: #F4F7FF;
            border-radius: 8px 8px 8px 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            margin-bottom: 20px;


            .app-cover {
                width: 80px;
                height: 80px;
                border-radius: 16px 16px 16px 16px;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 16px;
                }
            }

            .app-name {
                margin-top: 10px;
                width: 142px;
                height: 22px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #000000;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: inline-block;


            }
        }
        .noData{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img{
                width: 370px;
                height: 270px;
                margin-top: 120px;
            }
        }
    }


}

.app-detail-dialog {
    ::v-deep .el-dialog {
        ::v-deep .el-dialog__header {
            border-bottom: 1px solid #e6e7ea;
        }

        .title {
           
            margin: 0;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
            line-height: 33px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .h2 {
            width: 100%;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: flex;
            justify-content: center;
            // margin-top: 20px;
            padding: 10px 0;
        }

        .soft_introduction {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .content {
            width: 100%;
            height: 460px;
            margin-top: 20px;
            border: 1px solid #E6E7EB;
            border-radius: 8px;

            .soft-content {
                padding: 10px 30px;
                min-height: 200px;
                line-height: 26px;
            }

            .info-dialog-footer {
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;

                .link_item {
                    width: 200px;
                    height: 200px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    img{
                        width: 160px;
                        height: 160px;
                    }
                    a{
                        margin-top: 20px;
                    }
                }
            }

        }


        // ::v-deep .el-dialog__footer {
        //     border-top: 1px solid #e6e7ea;
        //     padding: 20px;



        //     a {
        //         padding: 7px 20px;
        //         font-size: 14px;
        //         border-radius: 4px;
        //         margin-right: 20px;
        //     }

        //     a.home {
        //         border: 1px solid #DCDFE6;
        //         color: #606266;

        //         &:hover {
        //             color: #409EFF;
        //             border-color: #c6e2ff;
        //             background-color: #ecf5ff;
        //         }
        //     }

        //     a.shop {
        //         color: #FFF;
        //         background-color: #409EFF;
        //         border-color: #409EFF;

        //         &:hover {
        //             background: #66b1ff;
        //             border-color: #66b1ff;
        //             color: #FFF;
        //         }
        //     }
        // }
    }
}
::v-deep .el-icon-close:before{
    line-height: 2.5 !important;
}
</style>